import { createClient } from '@supabase/supabase-js';

const projectUrl = process.env.REACT_APP_FIT_HAPPENS_SUPABASE_URL || 'https://fqqpgfxghdeqtwsyavhj.supabase.co';
const publishableKey = process.env.REACT_APP_FIT_HAPPENS_SUPABASE_ANON_KEY || '';

export const isFitHappensSupabaseConfigured = Boolean(projectUrl && publishableKey);

export const fitHappensSupabase = createClient(
  projectUrl,
  publishableKey || 'missing-publishable-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: 'fit-happens-auth',
    },
  },
);
